<bolt-modal id="paymentPreferencesModal"
    heading="Payment preferences"
    #paymentPreferencesModal
    type="question">
        <p class="bolt-space-bottom-lg bolt-body-copy-lg">To get electronic payments, enter your account info.</p>
        <p class="bolt-body-copy-lg">Electronic payments might not be possible in every situation. For example:</p>
        <ul class="bolt-space-bottom-2xl bolt-body-copy-lg">
            <li>You have a mortgage</li>
            <li>A contractor is paid directly</li>
            <li>A payment is split between multiple parties (you and a contractor)</li>
        </ul>
        <div class="bolt-space-bottom-2xl">
            <p class="bolt-body-copy-lg bolt-space-bottom-sm"><strong>How to find your routing and account numbers:</strong></p>
            <img alt="A check showing routing and account numbers. The routing number is the group of 9 digits on the bottom left. The account number is to the right of the routing number." src="./assets/images/Bank_check_routing_account_numbers_tcm826-244299.gif">
        </div>
        <bolt-waiting-indicator class="bolt-space-bottom-2xl" *ngIf="isLoading"></bolt-waiting-indicator>
        <div class="bolt-space-bottom-2xl" *ngIf="!isLoading">
            <form [formGroup]="paymentPreferencesForm"
                class="bolt-space-bottom-xl">
                <bolt-select ngDefaultControl
                    class="bolt-space-bottom-sm"
                    optionaltext="hide"
                    formControlName="paymentMethod"
                    id="paymentMethod"
                    label="Preferred payment method"
                     (change)="onPaymentMethodChange($event)"
                    [attr.error]="formErrorService.checkForError(paymentPreferencesForm, 'paymentMethod')">
                    <option *ngFor="let method of paymentMethods"
                        [value]="method.key">{{ method.value }}</option>
                </bolt-select>
                <div *ngIf="(!reftSelected || displayReftAccount)">
                    <bolt-textfield ngDefaultControl
                        class="bolt-space-bottom-sm"
                        optionaltext="hide"
                        formControlName="accountName"
                        id="accountName"
                        label="Account nickname"
                        maxlength="50"
                        [readonly]="isFormReadOnly || null"
                        (keydown)="onReadOnlyKeydown($event)"
                        (beforeinput)="blockReadOnlyInput($event)"
                        (paste)="blockReadOnlyInput($event)"
                        (drop)="blockReadOnlyInput($event)"
                        (cut)="blockReadOnlyInput($event)"
                        [arialabel]="isFormReadOnly ? 'Account nickname - Not editable' : 'Account nickname'"
                        [class.field-readonly]="isFormReadOnly"
                        [attr.error]="formErrorService.checkForError(paymentPreferencesForm, 'accountName')">
                    </bolt-textfield>
                    <bolt-select ngDefaultControl
                        *ngIf="isEditing && !newAccount"
                        optionaltext="hide"
                        class="bolt-space-bottom-sm"
                        formControlName="bankAccountType"
                        id="bankAccountType"
                        label="Bank account type"
                        [readonly]="isFormReadOnly || null"
                        (keydown)="onReadOnlyKeydown($event)"
                        [arialabel]="isFormReadOnly ? 'Bank account type - Not editable' : 'Bank account type'"
                        [class.field-readonly]="isFormReadOnly"
                        [attr.error]="formErrorService.checkForError(paymentPreferencesForm, 'bankAccountType')">
                        <option [value]="checking">Checking</option>
                        <option [value]="savings">Savings</option>
                    </bolt-select>
                    <bolt-textfield ngDefaultControl
                        optionaltext="hide"
                        class="bolt-space-bottom-sm"
                        formControlName="bankRoutingNumber"
                        id="bankRoutingNumber"
                        label="Bank routing number"
                        maxlength="9"
                        [readonly]="isFormReadOnly || null"
                        (keydown)="onReadOnlyKeydown($event)"
                        (beforeinput)="blockReadOnlyInput($event)"
                        (paste)="blockReadOnlyInput($event)"
                        (drop)="blockReadOnlyInput($event)"
                        (cut)="blockReadOnlyInput($event)"
                        [arialabel]="isFormReadOnly ? 'Bank routing number - Not editable' : 'Bank routing number'"
                        [class.field-readonly]="isFormReadOnly"
                        (blur)="onBankRoutingNumberBlur()"
                        [attr.error]="formErrorService.checkForError(paymentPreferencesForm, 'bankRoutingNumber')">
                    </bolt-textfield>

                    <div *ngIf="showBankName"
                        class="bolt-body-copy-md bolt-space-bottom-sm">
                        {{bankName}}
                    </div>

                    <bolt-textfield ngDefaultControl
                        optionaltext="hide"
                        formControlName="bankAccountNumber"
                        class="bolt-space-bottom-sm"
                        id="bankAccountNumber"
                        label="Bank account number"
                        maxlength="17"
                        [readonly]="isFormReadOnly || null"
                        (keydown)="onReadOnlyKeydown($event)"
                        (beforeinput)="blockReadOnlyInput($event)"
                        (paste)="blockReadOnlyInput($event)"
                        (drop)="blockReadOnlyInput($event)"
                        (cut)="blockReadOnlyInput($event)"
                        [arialabel]="isFormReadOnly ? 'Bank account number - Not editable' : 'Bank account number'"
                        [class.field-readonly]="isFormReadOnly"
                        [attr.error]="formErrorService.checkForError(paymentPreferencesForm, 'bankAccountNumber')">
                    </bolt-textfield>

                    <bolt-textfield ngDefaultControl *ngIf="!hasAccountDetails || isEditing"
                        class="bolt-space-bottom-sm"
                        formControlName="confirmBankAccountNumber"
                        id="confirmBankAccountNumber"
                        label="Confirm bank account number"
                        maxlength="17"
                        [readonly]="isFormReadOnly || null"
                        (keydown)="onReadOnlyKeydown($event)"
                        (beforeinput)="blockReadOnlyInput($event)"
                        (paste)="blockReadOnlyInput($event)"
                        (drop)="blockReadOnlyInput($event)"
                        (cut)="blockReadOnlyInput($event)"
                        [arialabel]="isFormReadOnly ? 'Confirm bank account number - Not editable' : 'Confirm bank account number'"
                        onCopy="return false"
                        onDrag="return false"
                        onDrop="return false"
                        onPaste="return false"
                        autocomplete=off
                        optionaltext="hide"
                        [attr.error]="formErrorService.checkForError(paymentPreferencesForm, 'confirmBankAccountNumber' )">
                    </bolt-textfield>
                </div>
            </form>

        <bolt-notification class="bolt-space-bottom-2xl" *ngIf="accountUpdateFailure">
            <b>We're having some trouble.</b>
            <br />
            Give us a call so we can help you. <a href="tel:1-800-421-3535">1-800-421-3535</a>.
        </bolt-notification>

        <bolt-notification #successNotification class="bolt-space-bottom-2xl" *ngIf="accountUpdateSuccess && !isEditing" type="success" tabindex="-1">
            <b>Success!</b>
            <br />
            Your claim may be paid electronically to account [{{successMsgAccountName}}] (some exceptions apply). If your home has a mortgage and the mortgage company is included on the payment, a check may be required.
        </bolt-notification>

        <p class="bolt-body-copy-lg bolt-space-bottom-xl" *ngIf="editState.isSecondaryAccount && !isEditing && !accountUpdateSuccess">
            To set this as your preferred payment method, click "Edit" to verify the account number.
        </p>

        <p class="bolt-body-copy-lg" *ngIf="(isEditing || reftSelected) && !accountUpdateSuccess">By clicking "Save" below, you are providing consent to Nationwide Mutual Insurance
            Company and any of its affiliates (collectively, “Nationwide”), to electronically credit the bank account listed
            above. This consent also authorizes Nationwide to make any necessary corrections by electronic debit or credit
            to the same account.</p>
        </div>
    <bolt-button-bar slot="modal-button-bar">
        <bolt-button *ngIf="shouldShowEditButton"
            (click)="edit()"
            slot="cancel">Edit</bolt-button>
        <bolt-button *ngIf="shouldShowCancelButton" (click)="close()"
                slot="back">Cancel</bolt-button>
        <bolt-button type="solid" *ngIf="shouldShowSaveButton"
            (click)="submit()"
            [disabled]="!paymentPreferencesForm.valid && !reftSelected || isLoading "
            slot="forward">Save</bolt-button>
        <bolt-button *ngIf="shouldShowCloseButton" (click)="close()"
               type="solid" slot="forward">Close</bolt-button>
    </bolt-button-bar>
</bolt-modal>
